import React, { useState } from 'react'
import { Col, Row, Modal, Input, message } from 'antd'
import FilterSelect from './Filters/FilterSelect'
import { updateCategory } from '../../../services/api/apiBatchShip'
import _ from 'lodash'

const CategoryEdit = ({ categoryItem = {}, reload, skus }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [payload, setPayload] = useState({})

    const handleOpenEdit = () => {
        setIsOpen(true)
        const { name = '', products = [] } = categoryItem
        setPayload({
            name: name,
            skus: products.map(i => i._id)
        })
    }

    const handleClose = () => {
        setIsOpen(false)
        setPayload({})
    }

    const _handleChangePayload = (data) => {
        setPayload(prePayload => ({
            ...prePayload,
            ...data
        }))
    }

    const handleEditCategory = async () => {
        try {
            if (!_.get(payload, 'name')) return message.error("Cần nhập tên danh mục sản phẩm.")
            const { data } = await updateCategory(payload, categoryItem._id)
            const { success, message: mess } = data

            if (!success) throw new Error(mess)
            message.success(`Chỉnh sửa danh mục thành công.`)
            reload()
            handleClose()

        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <React.Fragment>
            <i className="fa fa-edit text-primary fa-lg mr-2" onClick={handleOpenEdit} />
            <Modal
                title={`Chỉnh sửa danh mục`}
                visible={isOpen}
                onCancel={handleClose}
                className='modal-add-category'
                onOk={handleEditCategory}
                okText="Chỉnh sửa"
                cancelText="Hủy"
            >
                <Row
                    gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                    }}
                >
                    <Col className="gutter-row mb-2" span={24}>
                        <label className='mb-1 font-weight-bold'>Danh mục sản phẩm <span className='text-danger'>*</span></label>
                        <Input
                            value={payload.name}
                            placeholder='Nhập tên'
                            onChange={e => _handleChangePayload({ name: e.target.value })}
                        />
                    </Col>
                    <Col className="gutter-row" span={24}>
                        <FilterSelect
                            field='skus'
                            value={payload['skus']}
                            onChangeFilter={_handleChangePayload}
                            options={skus}
                            placeholder="Chọn SKU"
                            mode="multiple"
                            label='SKU'
                            type="create"
                        />
                    </Col>
                </Row>
            </Modal>
        </React.Fragment>
    )
}

export default CategoryEdit